var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3333 8.13116C8.3333 7.99954 8.37226 7.87087 8.44527 7.76136L11.8176 2.70281C12.113 2.25977 11.7954 1.66634 11.2629 1.66634H2.73701C2.20454 1.66634 1.88695 2.25977 2.1823 2.70281L5.55467 7.76136C5.62768 7.87087 5.66664 7.99954 5.66664 8.13116V12.0578C5.66664 12.5815 6.24261 12.9007 6.68664 12.6232L8.01997 11.7898C8.21489 11.668 8.3333 11.4544 8.3333 11.2245V8.13116ZM9.66664 8.53486C9.66664 8.40324 9.7056 8.27457 9.7786 8.16506L12.927 3.44241C13.8131 2.1133 12.8603 0.333008 11.2629 0.333008H2.73701C1.13962 0.333008 0.186832 2.1133 1.0729 3.44241L4.22134 8.16506C4.29435 8.27457 4.33331 8.40324 4.33331 8.53486V12.0578C4.33331 13.6287 6.06121 14.5864 7.3933 13.7538L8.72664 12.9205C9.3114 12.555 9.66664 11.9141 9.66664 11.2245V8.53486Z",
    fill: "#107DEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4c981dcbb0c7254beab59d27325735ec.svg";
export { ForwardRef as ReactComponent };